import { gql } from 'react-apollo';

export const deleteChurchGroup = gql`
  mutation deleteChurchGroup($input: DeleteChurchGroupInput!) {
    deleteChurchGroup(input: $input) {
      church_group {
        id
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/churchProfile/groups/mutations/deleteChurchGroup.js